import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzLove } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_LOVE: Record<
  Exclude<PageIdWoofzLove, PageIdWoofzLove.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.DOG_SEX_LOVE]: {
    id: PageId.DOG_SEX_LOVE,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.DOG_AGE_LOVE]: {
    id: PageId.DOG_AGE_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_LOVE]: {
    id: PageId.URGE_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.FEELINGS_LOVE]: {
    id: PageId.FEELINGS_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_1_LOVE]: {
    id: PageId.URGE_1_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.TALKING_LOVE]: {
    id: PageId.TALKING_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_FOLLOW_LOVE]: {
    id: PageId.DOG_FOLLOW_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.LICKING_LOVE]: {
    id: PageId.LICKING_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_2_LOVE]: {
    id: PageId.URGE_2_LOVE,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.BEHAVIOR_LOVE]: {
    id: PageId.BEHAVIOR_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.FEEL_GUILTY_LOVE]: {
    id: PageId.FEEL_GUILTY_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_3_LOVE]: {
    id: PageId.URGE_3_LOVE,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.DOG_REACT_LOVE]: {
    id: PageId.DOG_REACT_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.SATISFIED_LOVE]: {
    id: PageId.SATISFIED_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_ISSUES_LOVE]: {
    id: PageId.BEHAVIOR_ISSUES_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.YOUR_REACTION_LOVE]: {
    id: PageId.YOUR_REACTION_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_4_LOVE]: {
    id: PageId.URGE_4_LOVE,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.COMMANDS_LOVE]: {
    id: PageId.COMMANDS_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_LOVE]: {
    id: PageId.DOG_BREED_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_NAME_LOVE]: {
    id: PageId.DOG_NAME_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.LOVE_LOAD_SCREEN]: {
    id: PageId.LOVE_LOAD_SCREEN,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.DOG_PROFILE_LOVE]: {
    id: PageId.DOG_PROFILE_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.MOTIVATION_LOVE]: {
    id: PageId.MOTIVATION_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.FEEL_DOG_LOVE]: {
    id: PageId.FEEL_DOG_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.FREQUENCY_LOVE]: {
    id: PageId.FREQUENCY_LOVE,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.PREPARE_FLOW_LOVE]: {
    id: PageId.PREPARE_FLOW_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.EMAIL_LOVE]: {
    id: PageId.EMAIL_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.NEWSLETTER_URGE_LOVE]: {
    id: PageId.NEWSLETTER_URGE_LOVE,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.PERSONALIZED_PLAN_LOVE]: {
    id: PageId.PERSONALIZED_PLAN_LOVE,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.LAST_CHANCE_OFFER_LOVE]: {
    id: PageId.LAST_CHANCE_OFFER_LOVE,
  },
  [PageId.SUBSCRIPTIONS_LOVE]: {
    id: PageId.SUBSCRIPTIONS_LOVE,
  },
  [PageId.LAST_CHANCE_OFFER_2_LOVE]: {
    id: PageId.LAST_CHANCE_OFFER_2_LOVE,
  },
  [PageId.CANCEL_OFFER_LOVE]: {
    id: PageId.CANCEL_OFFER_LOVE,
  },
  [PageId.CHAT_UPSELL_LOVE]: {
    id: PageId.CHAT_UPSELL_LOVE,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_LOVE]: {
    id: PageId.UPSELL_LOVE,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_FEEDING_GUIDE_LOVE]: {
    id: PageId.UPSELL_FEEDING_GUIDE_LOVE,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE]: {
    id: PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_LOVE]: {
    id: PageId.DOWNLOAD_LOVE,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
